import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Alias } from '../../models/mailboxes.model';

@Component({
  selector: 'mprd-alias-details',
  templateUrl: 'alias-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AliasDetailsComponent {
  @Input() alias: Alias;
  @Output() removeAlias: EventEmitter<string> = new EventEmitter();
}
